export default __webpack_public_path__ + "static/media/330_dummy2016-yoga01-mobile-de.0fbbd821.png";